/*
  Bambusa — fermeture automatique du menu deroulant (mega-menu desktop).
  Le theme Impulse ne referme le <details> que sur un clic hors du menu :
  au scroll, au clic sur une vignette du menu ou au retour arriere, il restait ouvert.
*/
(function () {
  if (window.__bmbNavAutoClose) return;
  window.__bmbNavAutoClose = true;

  function closeAll() {
    var open = document.querySelectorAll('.site-nav__details[open]');
    if (!open.length) return false;
    for (var i = 0; i < open.length; i++) {
      open[i].removeAttribute('open');
      var summary = open[i].querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    }
    return true;
  }
  window.bmbCloseNav = closeAll;

  /* 1. Des qu'on scrolle, le menu se replie */
  var lastY = window.pageYOffset;
  window.addEventListener(
    'scroll',
    function () {
      var y = window.pageYOffset;
      if (Math.abs(y - lastY) < 10) return;
      lastY = y;
      closeAll();
    },
    { passive: true }
  );

  /* 2. Clic sur un lien ou un bouton du menu deroulant : on referme avant la navigation */
  document.addEventListener(
    'click',
    function (evt) {
      var target = evt.target;
      if (!target || !target.closest) return;
      if (target.closest('.site-nav__dropdown a, .site-nav__dropdown button')) closeAll();
    },
    true
  );

  /* 3. Touche Echap */
  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape' || evt.key === 'Esc') closeAll();
  });

  /* 4. Le curseur quitte le header : fermeture apres un court delai */
  var leaveTimer = null;
  function bindHeader() {
    var wrapper = document.getElementById('HeaderWrapper');
    if (!wrapper) return;
    wrapper.addEventListener('mouseleave', function () {
      if (leaveTimer) clearTimeout(leaveTimer);
      leaveTimer = setTimeout(closeAll, 400);
    });
    wrapper.addEventListener('mouseenter', function () {
      if (leaveTimer) {
        clearTimeout(leaveTimer);
        leaveTimer = null;
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindHeader);
  } else {
    bindHeader();
  }

  /* 5. Retour arriere navigateur (bfcache) */
  window.addEventListener('pageshow', function () {
    closeAll();
  });
})();
